import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import format from "date-fns/format"

import cn from "../../../utils/classname"

import { Icon } from "../../../ui/icon"
import NewsletterForm from "../../newsletter-form"

export default function Newsletters() {
  const {
    allSpNewsletter: { nodes },
  } = useStaticQuery<Queries.NewsletterListQuery>(graphql`
    query NewsletterList {
      allSpNewsletter(sort: { date: DESC }, limit: 3) {
        nodes {
          id
          url
          subject
          date
        }
      }
    }
  `)

  if (!nodes.length) {
    return null
  }

  return (
    <section
      id="newsletters"
      className="container-lg px-4 mt-[100px] lg:mt-[120px] scroll-my-[calc(var(--navbar)+100px)]"
    >
      <div className="text-jar-6 font-semibold text-neutral-12 mb-1">
        Our weekly newsletter
      </div>
      <div className="text-jar-4 text-neutral-11">
        Get the freshest news and resources in your inbox each week
      </div>
      <div className="lg:mt-10 lg:flex lg:justify-between">
        <ul className="my-8 w-full lg:my-0 lg:max-w-[503px]">
          {nodes.map(({ id, subject, date, url }, index) => {
            return (
              <li
                key={id}
                className={cn({
                  "pt-4": index > 0,
                  "border-b border-neutral-alpha-4 pb-4":
                    index < nodes.length - 1,
                })}
              >
                <a
                  href={url}
                  className="flex"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <div className="rounded-xl size-8 bg-neutral-alpha-3 flex-shrink-0 flex items-center justify-center p-1.5">
                    <Icon.Outline name="EmailEnvelope" className="size-5" />
                  </div>
                  <div className="pl-3">
                    <div className="font-medium text-jar-4 text-neutral-12 line-clamp-1">
                      {subject}
                    </div>
                    <div className="text-neutral-11 text-jar-3">
                      {format(new Date(date), "MMMM dd, yyyy")}
                    </div>
                  </div>
                </a>
              </li>
            )
          })}
        </ul>
        <div className="p-6 bg-neutral-alpha-2 rounded-2xl w-full lg:max-w-[416px] self-start">
          <div className="text-jar-4 font-medium text-neutral-12 mb-1">
            Subscribe to newsletter
          </div>
          <p className="text-jar-4 font-normal text-neutral-11 mb-6">
            Get the freshest news and resources for developers, designers and
            digital creators in your inbox{" "}
            <span className="italic">each week</span>
          </p>
          <NewsletterForm />
        </div>
      </div>
    </section>
  )
}
